import "./App.css";
import { tokens, isTokenInChain } from "@shreyaans/tokenlist";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TokenObject(props) {
  return (
    <div className="prose mb-5 card  bg-base-100 shadow-xl">
      <div className="p-6">
        <h2 className="capitalize mt-0">
          {" "}
          {props.tokenName}- {props.chain}
        </h2>
        <h4 className="break-all">
          Name: <b>{tokens[props.chain][props.tokenName].name}</b> <br />
          Symbol: <b>{tokens[props.chain][props.tokenName].symbol} </b>
          <br />
          Address: <b>{tokens[props.chain][props.tokenName].address}</b>
        </h4>
      </div>
    </div>
  );
}

function App() {
  const [name, setName] = useState("");
  const [token, settoken] = useState("");

  const [tokensArr, setTokensArr] = useState([
    { chain: "homestead", tokenName: "USDC" },
    { chain: "polygon", tokenName: "WMATIC" },
  ]);
  function handleClick() {
    if (isTokenInChain(name, token)) {
      setTokensArr([{ chain: `${name}`, tokenName: `${token}` }, ...tokensArr]);
    } else
      toast.error("Sorry this token isnt avaiable in this chain!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  }
  return (
    <div className="App">
      <header className="App-header">
        <div className="prose mb-0.5">
          <label className="prose capitalize">
            <h2>
              enter chain name and token name whose address you want to see
            </h2>
            <div className="mb-1 flex flex-nowrap flex-col justify-center	 items-center		">
              <input
                type="text"
                placeholder="chain name like polygon"
                className="input input-bordered w-full max-w-xs mb-1"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="text"
                placeholder="token name like USDT"
                className="input input-bordered w-full max-w-xs"
                value={token}
                onChange={(e) => settoken(e.target.value)}
              />
            </div>
            <button className="btn btn-accent" onClick={handleClick}>
              Get Token
            </button>
            <ToastContainer
              position="top-center"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
              theme="colored"
            />{" "}
          </label>
        </div>
        <br />
        <div className="flex justify-center  gap-4 content-center flex-wrap	">
          {tokensArr.length > 0 &&
            tokensArr.map((token) => (
              <TokenObject chain={token.chain} tokenName={token.tokenName} />
            ))}
        </div>
        <div className=" text-left card w-196 bg-teal-900	 text-primary-content ">
          <p className="p-6 prose break-words text-primary-content ">
            <h3 className="text-primary-content">Example tokens to test out in polgon and homestead chains - </h3>
            <p>
            USDT, USDC, BUSD, DAI, MATIC, SHIB, UNI, WBTC, LEO, LINK, CRO, QNT, APE, HT, AAVE, 
            MANA, SAND, MKR, TUSD, THETA
            </p>
          <p className="text-primary-content">
          </p>
            Supported chains and number of tokens in them: <br />
            <ul>
              <li>Polygon: 231 tokens</li>
              <li>Ethereum: 150 tokens</li>
              <li>Bsc (Binance Smart Chain): 208 tokens</li>
              <li>Avalanche: 102 tokens</li>
              <li>Cleo: 82 tokens</li>
              <li>Ftm (Fantom) :100</li>
            </ul>
            
          </p>
        </div>
        <br />
      </header>
    </div>
  );
}

export default App;
